import "../node_modules/ramverk/src/ramverk.css";
import "../node_modules/ramverk/src/form.css";
import "../node_modules/ramverk/src/form-layout.css";
import "./style.css";

import qrCode from "./account-qr-code.svg";

import {
  App,
  Form,
  feedback,
  get,
  post,
  put,
  binder,
  login,
  attach,
  getClientInfo,
  URLParams,
} from "ramverk";

binder.init();
const langSwitch = document.getElementById("lang-switch");
attach(langSwitch, () => "~In English|På svenska~");
langSwitch.addEventListener("click", () => binder.toggleLang());

attach(
  document.querySelector("title"),
  () => "~Ansök om lånekonto|Apply for a library account~",
);

const app = new App();
const returnURL =
  (login.expireURL =
  login.rejectURL =
    URLParams().returnURL || app.mountPoint + "/apply");

app.reset = () => {
  login.clear();
  location.href = returnURL;
};

login.store = false;

// Vid lokal test:
//login.backend = '';

app.add("/apply", (view) =>
  attach(
    view.element,
    () => `
    <h1>~Ansök om lånekonto|Apply for a library account~</h1>
    <p>~Är du student/personal vid Lnu?|Are you a student/employee at Linnaeus University?~</p>
    <button type="button" data-open="/exists">~Ja|Yes~</button>
    <button type="button" data-open="/public-form">~Nej|No~</button>`,
  ),
);

app
  .add("/exists", async (view) => {
    const form = new Form();
    const details = await login.getAlmaDetails();

    attach(
      view.element,
      () => `
        <p>~Du är redan registrerad som låntagare. Har du glömt din PIN-kod kan du ange en ny nedan. Ange även en e-postadress för utskick av påminnelser om lån m.m.|You are already registered. If you have forgotten your PIN code you may change it using the form below. In addition, provide an e-mail address for notices about loans etc.~</p>
        <form autocomplete="off">
            <section>
                <div>
                    <div>
                        <label for="pin_number">~Ny PIN-kod|New PIN code~ <span class="form-label-note">(~4 siffror|4 digits~)</span></label>
                        <input name="pin_number" type="password" required>
                    </div>
                    <div>
                        <label for="confirm_pin_number">~Bekräfta PIN-kod|Confirm PIN code~</label>
                        <input name="confirm_pin_number" type="password" data-confirm="pin_number" required>
                    </div>
                </div>
                <div>
                    <div>
                        <label for="email_address">~E-postadress|E-mail address~</label>
                        <input name="email_address" type="email" required>
                    </div>
                    <div>
                        <label for="confirm_email_address">~Bekräfta e-postadress|Confirm e-mail address~</label>
                        <input name="confirm_email_address" type="text" data-confirm="email_address" data-feedback="E-postadresserna stämmer inte överens.|The email addresses do not match." required>
                    </div>
                </div>
            </section>
            ${view.feedback}
            <button type="button" data-reset>~Avbryt|Cancel~</button>
            <button class="form-submit" type="button">~Byt PIN-kod|Change PIN code~</button>
        </form>`,
      (e) => form.bind(e),
    );

    form.set("email_address", details.preferred_email);

    form.submit = async () => {
      if (form.validate()) {
        try {
          const fields = form.values();
          const changes = {
            pin_number: fields.pin_number,
          };

          if (fields.email_address !== details.preferred_email)
            changes.contact_info = {
              email: [
                {
                  preferred: true,
                  segment_type: "INTERNAL",
                  email_address: fields.email_address,
                  email_type: [{ value: "personal" }],
                },
              ],
            };

          await put(`${app.mountPoint}/`, changes, {
            headers: login.authHeader,
          });

          login.clear();
          app.open("/updated");
        } catch (error) {
          console.log(error);
          view.error(feedback.unexpectedError);
        }
      }
    };
  })
  .guard(login, { addedView: "/added", extendedAlmaForm: true });

app.add("/added", (view) => {
  attach(
    view.element,
    () => `
        <p>~Du är nu registrerad som låntagare. Ett mejl med
        ${login.session.extendedAlmaForm ? "PIN-koden m.m." : "en PIN-kod"}
        har skickats till ${login.session.email || "?"}. Du lånar i
        automaterna med <em>ditt personnummer</em> (eller med ditt
        Lnu-kort) och <em>PIN-koden</em>.|You are now registered. An e-mail with
        ${login.session.extendedAlmaForm ? "the PIN code etc." : "a PIN code"}
        has been sent to ${login.session.email || "?"}. Borrow
        items using the self-service machines by inputting <em>your
        Personal identity number</em> (or Swedish "personnummer") and
        <em>the PIN code</em>. You may also use your Lnu key card for
        identification.~</p>

        <button type="button" data-reset>~Återgå|Return~</button>`,
  );
});

app.add("/updated", (view) => {
  attach(
    view.element,
    () => `
        <p>~PIN-koden har ändrats.|The PIN code has been updated.~</p>

        <button type="button" data-reset>~Återgå|Return~</button>`,
  );
});

app.add("/public-form", (view) => {
  const form = new Form();

  attach(
    view.element,
    () => `
        <p>~Fyll i och skicka nedanstående formulär.|Fill in and send the form below.~</p>
        <form autocomplete="off">
            <section>
                <div class="halfwidth-row">
                    <div>
                        <label for="pnr">~Personnummer|Personal identity number~ <span class="form-label-note">(~12 siffror|12 digits~)</span></label>
                        <input name="pnr" type="text" data-pnr="check" required>
                    </div>
                </div>
            </section>
            <section>
                <div>
                    <div>
                        <label for="first_name">~Förnamn|First name~</label>
                        <input name="first_name" type="text" data-autoformat required>
                    </div>
                    <div>
                        <label for="last_name">~Efternamn|Last name~</label>
                       <input name="last_name" type="text" data-autoformat required>
                    </div>
                </div>
                <div>
                    <div>
                        <label for="street_address">~Gatuadress|Street address <span class="form-label-note">(in Sweden)</span>~</label>
                        <input name="street_address" type="text" data-autoformat required>
                    </div>
                    <div class="field-25">
                        <label for="co_address" class="form-optional">C/o</label>
                        <input name="co_address" type="text" data-autoformat>
                    </div>
                </div>
                <div>
                    <div class="field-25">
                        <label for="postal_code">~Postnummer|Postal code~</label>
                        <input name="postal_code" type="text" data-postalcode required>
                    </div>
                    <div>
                        <label for="city">~Ort|City~</label>
                        <input name="city" type="text" data-autoformat required>
                    </div>
                </div>
                <div>
                    <div>
                        <label for="email_address">~E-postadress|E-mail address~</label>
                        <input name="email_address" type="email" required>
                    </div>
                    <div>
                        <label for="confirm_email_address">~Bekräfta e-postadress|Confirm e-mail address~</label>
                        <input name="confirm_email_address" type="text" data-confirm="email_address" data-feedback="E-postadresserna stämmer inte överens.|The email addresses do not match." required>
                    </div>
                </div>
                <div class="halfwidth-row">
                    <div>
                        <label for="phone_number" class="form-optional">~Telefonnummer|Phone number <span class="form-label-note">(in Sweden)</span>~</label>
                        <input name="phone_number" name="tel" type="text" pattern="[\\-\\s0-9]{7,15}" data-feedback="~Telefonnummer får innehålla endast siffror 0-9 och bindestreck.|Phone number may contain only digits 0-9 and dash (-).~">
                    </div>
                </div>
                <div>
                    <div>
                        <label for="pin_number">~Välj PIN-kod|Choose PIN code~ <span class="form-label-note">(~4 siffror|4 digits~)</span></label>
                        <input name="pin_number" type="password" data-pin_number required>
                    </div>
                    <div>
                        <label for="confirm_pin_number">~Bekräfta PIN-kod|Confirm PIN code~</label>
                        <input name="confirm_pin_number" type="password" data-confirm="pin_number" required>
                    </div>
                </div>
                <div>
                    <div class="form-comment">~PIN-koden används vid lån i utlåningsautomaterna.|The PIN code is needed when using the self-checkout machines.~</div>
                </div>
            </section>
            <section><div>
                <div>
                    <label>~Meddelanden från biblioteket vill jag få på|I want to get messages from the library in~:</label>
                    <fieldset>
                        <label><input name="preferred_language" value="sv" type="radio" ~checked|~>~svenska|Swedish~</label>
                        <label><input name="preferred_language" value="en" type="radio" ~|checked~>~engelska|English~</label>
                    </fieldset>
                </div>
            </div></section>
            ${view.feedback}
            <button class="form-submit" type="button">~Ansök|Apply~</button>
        </form>`,
    (e) => form.bind(e),
  );

  form.submit = () => login.conditions(view);

  // Se login.conditions()
  view.accept = async () => {
    try {
      await post(`${app.mountPoint}/`, form.values(), {
        headers: login.authHeader,
      });
      app.open("/sent-public");
    } catch (error) {
      console.log(error);
      view.error(feedback.unexpectedError);
    }
  };
});

app.add("/sent-public", (view) => {
  attach(
    view.element,
    () => `
        <p>~Vi har fått din ansökan.|We have received your application.~</p>
        <p>~Besök informationsdisken på universitetsbiblioteket för att hämta ditt lånekort och kunna låna böcker. Ta med legitimation när du kommer.|Please visit the information desk at the university library to collect your library card and start borrowing books. Bring identification with you.~</p>

        <button type="button" data-reset>~Återgå|Return~</button>`,
  );
});

app
  .add("/apply-distance", async (view) => {
    try {
      await get(`${app.mountPoint}/update-distance-status`, {
        headers: login.authHeader,
      });

      attach(
        view.element,
        () => `
            ~<p>Du uppfyller kraven för distansservice. Du kan nu
            beställa hem tryckta böcker i vår söktjänst, OneSearch.</p>
            <p><a href="https://lnu.se/ub/kontakta-biblioteket/Universitetsbibliotekets-distansservice">
                Läs mer om bibliotekets distansservice
            </a></p>|
            <p>You are eligable to make use of the distance service. You may now
            request printed books using our discovery service, OneSearch.</p>
            <p><a href="https://lnu.se/en/library/contact-the-library/distance-service/">
                Read more about the library's distance service
            </a></p>~`,
      );
    } catch (error) {
      if (!error.xhr || error.status !== 403) throw error;

      const form = new Form();

      attach(
        view.element,
        () => `
            <h1>~Ansök om bibliotekets distansservice|Apply for the library's distance service~</h1>
            <p>
                ~Bibliotekets distansservice är endast tillgänglig för dig
                som registrerat dig på en distanskurs vid
                Linnéuniversitetet och <em>inte</em> bor inom Växjö eller
                Kalmar kommun.|
                The library's distance service is only available for
                students of Linnaeus University distance courses who live
                <em>outside</em> the municipalities of Växjö and Kalmar.~
            </p>
            <p>
                ~Ange adressen dit du vill att lånade böcker skickas och
                ange kurskod för distanskursen.|
                Please provide an address to which borrowed books are to
                be sent, and provide the course code of the distance
                course.~
            </p>
            <form autocomplete="off">
                <section>
                    <div>
                        <div>
                            <label for="street_address">~Gatuadress|Street address~ <span class="form-label-note">(~utanför Växjö/Kalmar kommun, i Sverige eller övriga Norden|outside of Växjö/Kalmar, in Sweden or other Nordic country~)</span></label>
                            <input name="street_address" type="text" data-autoformat required>
                        </div>
                        <div class="field-25">
                            <label for="co_address" class="form-optional">C/o</label>
                            <input name="co_address" type="text" data-autoformat>
                        </div>
                    </div>
                    <div>
                        <div>
                            <label for="postal_code">~Postnummer|Postal code~</label>
                            <input name="postal_code" type="text" data-postalcode="distance" required>
                        </div>
                        <div>
                            <label for="city">~Ort|City~</label>
                            <input name="city" type="text" data-autoformat required>
                        </div>
                        <div>
                            <label for="country">~Land|Country~</label>
                            <select name="country">
                                <option value="" selected>~Sverige|Sweden~</option>
                                <option value="DNK">~Danmark|Denmark~</option>
                                <option value="FIN">Finland</option>
                                <option value="ISL">~Island|Iceland~</option>
                                <option value="NOR">~Norge|Norway~</option>
                            </select>
                        </div>
                    </div>
                </section>
                <section>
                    <div class="halfwidth-row">
                        <div>
                            <label for="course_code">~Kurskod för distanskurs(er)|Course code for distance course(s)~</label>
                            <input name="course_code" type="text" required>
                        </div>
                    </div>
                </section>
                ${view.feedback}
                <button class="form-submit" type="button">~Ansök|Apply~</button>
            </form>`,
        (e) => form.bind(e),
      );

      form.submit = async () => {
        try {
          const fields = form.values();
          const details = await login.getAlmaDetails({ view: "full" });

          fields.name = details.full_name;
          fields.email = details.preferred_email;
          fields.lang = details.preferred_language.value;

          await post(`${app.mountPoint}/apply-distance`, fields, {
            headers: login.authHeader,
          });
          app.open("/sent-distance");
        } catch (error) {
          console.log(error);
          view.error(feedback.unexpectedError);
        }
      };
    }
  })
  .guard(login, { extendedAlmaForm: true });

app
  .add("/sent-distance", async (view) => {
    const details = await login.getAlmaDetails({ view: "full" });

    attach(
      view.element,
      () => `
        <p>~Ansökan har skickats. Om vi behöver kompletterande uppgifter återkopplar vi till ${details.preferred_email} (under terminstid).
        Hör du inget från oss är din ansökan godkänd.|
        The application has been sent. If we need further information we will contact you on ${details.preferred_email}.
        If you do not hear from us, it means that your application has been approved.~</p>

        <button type="button" data-reset>~Återgå|Return~</button>`,
    );
  })
  .guard(login, { message: null });

getClientInfo().then((client) => {
  const link = client.restricted
    ? `<a class="disabled-link" href="">https://account.lnu.se</a> &rarr; <img style="width: 60px; height: 60px; vertical-align: top" src="${qrCode}">`
    : '<a href="https://account.lnu.se">https://account.lnu.se</a>.';
  login.message = `<p>~Saknar du sådant konto beställer du ett på|If you lack such an account, please request one at~ ${link}</p>`;

  app.init();
});

/**
 * Global händelselyssnare för deklarativ navigering och kontroll.
 * Ersätter inline-skript (onclick) för att möta kraven i Content Security Policy (CSP).
 * Använder event delegation för att hantera element som skapas dynamiskt i appen.
 */
document.addEventListener('click', (e) => {
    // Letar efter närmaste element med data-open (fungerar även om man klickar på en span inuti knappen)
    const openBtn = e.target.closest('[data-open]');
    if (openBtn) {
        app.open(openBtn.getAttribute('data-open'));
        return;
    }

    if (e.target.closest('[data-reset]')) {
        app.reset();
    }
});
